/* doucilune — interactions (reveal, flip, tilt, parallaxe, menu, header) */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document;

  function menu() {
    var panel = root.querySelector('[data-mobile-nav]');
    var toggle = root.querySelector('[data-nav-toggle]');
    if (!panel || !toggle) return function () {};
    function open(v) {
      panel.style.visibility = v ? 'visible' : 'hidden';
      panel.style.transform = v ? 'translateY(0)' : 'translateY(-100%)';
      toggle.setAttribute('aria-expanded', v ? 'true' : 'false');
      document.body.style.overflow = v ? 'hidden' : '';
      if (!v) setTimeout(function () { panel.style.visibility = 'hidden'; }, 420);
    }
    toggle.addEventListener('click', function () { open(true); });
    var close = root.querySelector('[data-nav-close]');
    if (close) close.addEventListener('click', function () { open(false); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-nav-link]'), function (a) {
      a.addEventListener('click', function () { open(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    return function () { open(false); };
  }
  var closeMenu = menu();

  function layout() {
    var w = window.innerWidth;
    var nav = root.querySelector('[data-nav]');
    var toggle = root.querySelector('[data-nav-toggle]');
    var cta = root.querySelector('[data-header-cta]');
    if (nav) nav.style.display = w >= 1000 ? 'flex' : 'none';
    if (toggle) toggle.style.display = w >= 1000 ? 'none' : 'inline-flex';
    if (cta) cta.style.display = w >= 1000 ? 'inline-flex' : 'none';
    if (w >= 1000) closeMenu();

    var fg = root.querySelector('[data-footer-grid]');
    if (fg) {
      fg.style.gridTemplateColumns = w >= 1060 ? '1.25fr .8fr .8fr 1fr 1.3fr' : (w >= 680 ? 'repeat(2,1fr)' : '1fr');
      var contact = fg.lastElementChild;
      if (contact) contact.style.gridColumn = (w >= 680 && w < 1060) ? '1 / -1' : 'auto';
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-cards]'), function (g) {
      g.style.gridTemplateColumns = w >= 1040 ? 'repeat(4,1fr)' : (w >= 620 ? 'repeat(2,1fr)' : '1fr');
    });
    var head = root.querySelector('[data-head]');
    if (head) head.style.gridTemplateColumns = w >= 900 ? '.4fr 1fr' : '1fr';
    Array.prototype.forEach.call(root.querySelectorAll('[data-hero],[data-split]'), function (el) {
      el.style.gridTemplateColumns = w >= 900 ? '1fr 1fr' : '1fr';
    });
    var hero = root.querySelector('[data-hero]');
    if (hero && w >= 900) hero.style.gridTemplateColumns = '1.02fr 1fr';
    Array.prototype.forEach.call(root.querySelectorAll('[data-diptych]'), function (el) {
      el.style.gridTemplateColumns = w >= 760 ? 'repeat(2,1fr)' : '1fr';
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bleed],[data-bleed-rev]'), function (el) {
      el.style.gridTemplateColumns = w >= 900 ? '1.05fr .95fr' : '1fr';
    });
    var grid = root.querySelector('[data-grid]');
    if (grid) grid.style.gridTemplateColumns = w >= 900 ? '1.35fr 1fr' : '1fr';
    var frow = root.querySelector('[data-form-row]');
    if (frow) frow.style.gridTemplateColumns = w >= 640 ? '1fr 1fr' : '1fr';
  }
  layout();
  window.addEventListener('resize', layout, { passive: true });

  /* apparitions */
  var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
  if (reduced) {
    reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
  } else {
    reveals.forEach(function (el) {
      var tilt = el.hasAttribute('data-tilt') || el.tagName === 'FIGURE';
      el.style.opacity = '0';
      el.style.transformOrigin = 'center top';
      el.style.transform = tilt ? 'perspective(1200px) rotateX(6deg) translateY(34px) scale(.985)' : 'translateY(28px)';
      el.style.transition = 'opacity 1s cubic-bezier(.22,.61,.36,1), transform 1.05s cubic-bezier(.22,.61,.36,1)';
      el.style.willChange = 'opacity, transform';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, d = parseInt(el.dataset.d || '0', 10);
        setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; el.dataset.seen = '1'; }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* cartes : retournement 3D */
  Array.prototype.forEach.call(root.querySelectorAll('[data-flip]'), function (card) {
    var inner = card.querySelector('[data-flip-inner]');
    if (!inner) return;
    var flipped = false;
    function set(v) {
      flipped = v;
      inner.style.transform = v ? 'rotateY(180deg)' : 'rotateY(0deg)';
      card.style.transition = 'transform .7s cubic-bezier(.22,.61,.36,1)';
      card.style.transform = v ? 'translateY(-7px)' : 'translateY(0)';
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      card.addEventListener('mouseenter', function () { set(true); });
      card.addEventListener('mouseleave', function () { set(false); });
      card.addEventListener('focus', function () { set(true); });
      card.addEventListener('blur', function () { set(false); });
    }
    card.addEventListener('click', function () { set(!flipped); });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(!flipped); }
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-card-icon]'), function (icon) {
    var card = icon.closest('article');
    if (!card) return;
    card.addEventListener('mouseenter', function () {
      icon.style.transform = 'translateY(-4px) rotate(-4deg)';
      if (!reduced) card.style.transform = 'perspective(1200px) rotateX(-1.2deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      icon.style.transform = 'none';
      card.style.transform = 'none';
    });
  });

  /* défilement : header, lockup, parallaxe */
  var header = root.querySelector('[data-header]');
  var lockup = root.querySelector('[data-lockup]');
  var brand = root.querySelector('[data-brand]');
  var parallax = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.scrollY || document.documentElement.scrollTop;
    if (header) {
      header.style.borderBottomColor = y > 12 ? 'rgba(58,50,41,.1)' : 'transparent';
      header.style.boxShadow = y > 12 ? '0 14px 30px -28px rgba(58,50,41,.9)' : 'none';
    }
    if (reduced) return;
    var span = lockup ? Math.max(lockup.offsetHeight, 240) : 320;
    var p = Math.max(0, Math.min(1, y / span));
    var e = p * p * (3 - 2 * p);
    if (lockup) {
      lockup.style.transform = 'translateY(' + (-42 * e).toFixed(2) + 'px) scale(' + (1 + 0.14 * e).toFixed(3) + ')';
      lockup.style.opacity = String(1 - 0.92 * e);
    }
    if (brand) brand.style.transform = 'scale(' + (0.97 + 0.13 * e).toFixed(3) + ')';
    var vh = window.innerHeight || 800;
    parallax.forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var k = parseFloat(img.dataset.parallax || '0.05');
      var centre = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translate3d(0,' + (-centre * k * vh).toFixed(1) + 'px,0) scale(' + (1 + k * 1.6).toFixed(3) + ')';
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  frame();

  /* survol : styles style-hover / style-focus déclarés en HTML */
  Array.prototype.forEach.call(root.querySelectorAll('[style-hover],[style-focus]'), function (el) {
    var base = el.getAttribute('style') || '';
    function apply(extra) { el.setAttribute('style', base + ';' + extra); }
    var h = el.getAttribute('style-hover'), fo = el.getAttribute('style-focus');
    if (h) {
      el.addEventListener('mouseenter', function () { apply(h); });
      el.addEventListener('mouseleave', function () { el.setAttribute('style', base); });
    }
    if (fo) {
      el.addEventListener('focus', function () { apply(fo); });
      el.addEventListener('blur', function () { el.setAttribute('style', base); });
    }
  });

})();
